<style lang="less">
.sms-code {
  line-height: 30px;
  width: 90px;
  text-align: right;
  float: right;
  font-size: 13px;
  border-radius: 3px;
  cursor: pointer;
}
.disable {
  color: #bdc0c5;
  font-size: 13px;
}
</style>

<template>
  <div :class="{ 'sms-code': 'sms-code', disable: isDisable }" :style="pos" @click="getSmsCode">{{ tip }}</div>
</template>

<script>
let timer = null
const INIT_TIP = '获取验证码'
const PENDING_TIP = '等待中'
const DEFAULT_SECOND = 60
export default {
  props: ['times', 'pos', 'disable', 'coundown', 'status', 'resetCountdown'],
  data() {
    return {
      tip: INIT_TIP,
      isDisable: this.disable,
      myTimes: this.times || DEFAULT_SECOND,
    }
  },
  watch: {
    resetCountdown(nv) {
      if (!nv) {
        return
      }
      if (timer) {
        clearInterval(timer)
        timer = null
      }
      this.tip = INIT_TIP
      this.isDisable = true
      this.myTimes = this.times
    },
    status: function () {
      // 1:获取验证码， 2:等待中
      if (this.status == 1) {
        this.tip = INIT_TIP
      } else {
        this.tip = PENDING_TIP
      }
    },
    disable: function (v) {
      console.log('disable ', v)
      this.isDisable = this.disable
    },
    // coundown: function (v) {
    //   if (v) {
    //     console.log('coundown ',v)
    //     this.startCountDown()
    //   }
    // }
  },
  methods: {
    getSmsCode: function () {
      if (!!this.isDisable) {
        return
      }
      this.startCountDown()
      this.$emit('smsCodeClick')
    },
    startCountDown: function () {
      const self = this
      this.isDisable = true
      if (timer) {
        clearInterval(timer)
        timer = null
      }
      timer = setInterval(() => {
        if (self.myTimes <= 0) {
          clearInterval(timer)
          timer = null
          self.myTimes = self.times || DEFAULT_SECOND
          self.tip = INIT_TIP
          self.isDisable = false
          self.$emit('countDownEnd')
          return
        }
        self.tip = `${self.myTimes--} 秒`
      }, 1000)
    },
  },
}
</script>
